<template>
    <b-form-select
        variant="light"
        @change="$emit('statusFiltered', {status: $event})"
        :options="options"
        :value="$route.query['filter[status]'] ? $route.query['filter[status]'] : null">
    </b-form-select>
</template>

<script>
    export default {
        name: 'StatusSelect',
        props: {
            options: {
                type: Array,
                required: true
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/UserPanel/Elements/StatusSelect.vue